import { Box, Skeleton } from "@mui/material";

const ChatMessageSkeleton = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
        }}
      >
        <Skeleton variant="rounded" width={40} height={40} />
        <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
          <Skeleton
            variant="text"
            sx={{ fontSize: "16pxrem" }}
            animation="wave"
            width="100%"
          />
          <Skeleton
            variant="text"
            sx={{ fontSize: "16px" }}
            animation="wave"
            width="80%"
          />
          <Skeleton
            variant="text"
            sx={{ fontSize: "16px" }}
            animation="wave"
            width="70%"
          />
        </Box>
      </Box>
    </>
  );
};

export default ChatMessageSkeleton;
